export default __webpack_public_path__ + "static/media/clipboard-x.a4aca466.svg";